<template>
  <div id="manage-intent" v-if="intent">
    <div>
      <v-layout wrap style="border-bottom: 1px solid #eee" class="mb-3" v-if="!isWelcome">
        <v-flex
          xs12
          sm5
          md6
          form-control
          :class="{ 'has-error': errors.has('intentName') }"
          class="px-2 pt-2"
        >
          <input
            type="text"
            v-if="!isDefault"
            class="form-control"
            :placeholder="$t('Conversation')"
            v-model="intent.intentname"
            name="intentName"
            :data-vv-as="$t('Conversation')"
            aria-describedby="Intent Name"
            v-validate="
              'required|excludednew:{default},{welcome}' + (excludedName ? ',' + excludedName : '')
            "
          />
          <div v-else>
            <template v-if="intent.intentname == '{default_comment_to_inbox}'">
              <p>{{ $t('More Comment to Inbox') }}</p>
            </template>
            <template v-else>
              <p>{{ $t('Default Conversation') }}</p>
            </template>
          </div>
          <span class="text-error" v-show="errors.has('intentName')">{{
            errors.first('intentName')
          }}</span>
        </v-flex>
        <v-flex xs12 sm7 md6 class="px-2 pt-2">
          <slot name="action"></slot>
          <div v-if="showReplyCommentSelectPost" class="text-xs-right">
            <template v-if="$store.getters.getPackage == 'premium'">
              <v-btn color="primary" small outline @click="showSelectPost = true">
                <template v-if="postidlist.includes.length == 0 && postidlist.excludes.length == 0">
                  {{ $t('Replying all post(s)') }}
                </template>
                <template v-else-if="postidlist.includes.length > 0">
                  {{ $t('Post(s) will be replied') }} ({{ postidlist.includes.length }})
                </template>
                <template v-else-if="postidlist.excludes.length > 0">
                  {{ $t("Post(s) won't be replied") }} ({{ postidlist.excludes.length }})
                </template>
                <v-icon small>edit</v-icon>
              </v-btn>

              <intent-select-post
                :includePost="intent.postidlist"
                :excludePost="intent.exceptpostidlist"
                :show="showSelectPost"
                :useexclude="true"
                @save="saveFilterPost"
                @close="showSelectPost = false"
              ></intent-select-post>
            </template>

            <v-btn color="grey" disabled v-else outline>
              <template v-if="postidlist.includes.length == 0 && postidlist.excludes.length == 0">
                {{ $t('Replying all post(s)') }}
              </template>
              <template v-else-if="postidlist.includes.length > 0">
                {{ $t('Post(s) will be replied') }} ({{ postidlist.includes.length }})
              </template>
              <template v-else-if="postidlist.excludes.length > 0">
                {{ $t("Post(s) won't be replied") }} ({{ postidlist.excludes.length }})
              </template>
              <v-icon class="ml-1">edit</v-icon>
              <v-premium-lock></v-premium-lock>
            </v-btn>
          </div>
        </v-flex>
        <v-flex xs12 class="px-2 pt-1 pb-2" align-end>
          <v-layout>
            <v-flex class="text-xs-left text-sm-right">
              <span class="mr-2">{{ $t('Turn On/Off Conversation') }}</span>
              <toggle-button
                :value="intent.intentstatus"
                :sync="true"
                :color="$vuetify.theme.success"
                @change="onChangeIntentStatus"
                :labels="{ checked: 'ON', unchecked: 'OFF' }"
              />
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs12 sm6 class="pa-1 pl-2 pr-2">
          <template v-if="!isDefault">
            <intent-question v-model="intent.q_val"></intent-question>
          </template>
          <template v-else>
            <p class="small" style="margin-bottom: 0px">
              <template v-if="intent.intentname == '{default}'"></template>
              <template v-else-if="intent.intentname == '{default_comment_to_inbox}'"></template>
            </p>
          </template>
        </v-flex>
        <v-flex xs12 sm6 class="pa-1">
          <!-- <div class="hr show-on-small hide-on-med-and-up" style="margin: 15px -15px"></div> -->
          <template v-if="(isReplyComment && isCommentToInbox) || isLiveStream">
            <intent-comment :isLiveStream="isLiveStream" v-model="messages"></intent-comment>
          </template>
          <template v-else-if="isWelcome">
            <slot name="welcome"></slot>
          </template>
          <template v-else>
            <div>
              <intent-group v-model="messages"></intent-group>
            </div>
            <template v-if="!isWelcome && !isCommentToInbox">
              <div class="hr"></div>
              <p class="small" style="margin-top: 10px">{{ $t('Choice') }}</p>

              <div class="form-control" :class="{ 'has-error': errorTag.length > 0 }">
                <tags
                  v-model="reply"
                  :tags="replies"
                  @tags-changed="addReplies"
                  @before-adding-tag="checkQuickReply"
                  style="margin-bottom: 5px"
                  :btnText="$t('Add choice')"
                ></tags>
                <!-- <vue-tags-input v-model="reply" :tags="replies" @tags-changed="newTags => replies = newTags" @before-adding-tag="checkQuickReply" /> -->
                <span class="text-error" v-if="errorTag.length > 0">
                  <template v-if="errorTag.includes('overmaxlength')">{{
                    $t('Message cannot be longer than 20 alphabets')
                  }}</template>
                  <template v-else-if="errorTag.includes('overtagmax')">{{
                    $t('Choices cannot be more than 10 items')
                  }}</template>
                  <template v-else-if="errorTag.includes('duplicate')">{{
                    $t('Duplicate Choice')
                  }}</template>
                </span>
              </div>
            </template>
            <template v-else></template>
          </template>
        </v-flex>
      </v-layout>

      <template v-if="selectedBot.theme == 'universalutilities'">
        <template v-if="selectedBot.uu_areaname != '' && selectedBot.uu_areaname != null">
          <div class="mt-4">
            <div class="hr"></div>
            <div class="pa-3">
              <div class="caption">ประปา</div>
              <div class="form-control">
                <span class="primary--text">{{ selectedBot.uu_areaname }}</span>
              </div>
            </div>
          </div>
        </template>
        <template v-else-if="selectedBot.uu_areaname == '' || selectedBot.uu_areaname == null">
          <div class="mt-4">
            <div class="hr"></div>
            <div class="pa-3">
              <div class="caption">ประปา</div>
              <div class="form-control" :class="{ 'has-error': errors.has('uuAreaName') }">
                <multiselect
                  v-model="intent.intentgroup"
                  :options="areaName"
                  selectLabel
                  selectedLabel
                  :searchable="false"
                  deselect-label
                  data-vv-as="ประปา"
                  data-vv-name="uuAreaName"
                ></multiselect>
                <span class="text-error" v-show="errors.has('uuAreaName')">{{
                  errors.first('uuAreaName')
                }}</span>
              </div>
            </div>
          </div>
        </template>
      </template>

      <div class="mt-4">
        <div class="hr"></div>
        <div class="text-xs-center" style="margin: -13px">
          <a
            class="text btn-advanced"
            href="javascript:void(0);"
            @click="onShowAdvance"
            style="position: relative"
          >
            {{ $t('Advanced') }}
            <i
              class="fa"
              :class="{ 'fa-angle-down': !showAdvanced, 'fa-angle-up': showAdvanced }"
            ></i>
            <!-- <v-premium-lock :inline="true"></v-premium-lock> -->
          </a>
        </div>

        <template>
          <div
            style="margin-top: 25px"
            v-show="showAdvanced || errors.has('context_in') || errors.has('startdate')"
          >
            <v-tabs v-model="advancedTab" slider-color="primary" touchless>
              <v-tab :key="0" ripple>{{ $t('Classification') }}</v-tab>
              <v-tab :key="1" ripple>{{ $t('Customer') }}</v-tab>
              <v-tab v-if="!isCommentToInbox && !isLiveStream" :key="2" ripple>
                {{ $t('Context') }}
              </v-tab>
              <v-tab :key="3" ripple>{{ $t('Timer') }}</v-tab>
              <v-tab :key="4" ripple>{{ $t('Line Notify') }}</v-tab>
              <v-tab :key="5" ripple v-if="selectedBot.theme == 'ticket'">
                {{ $t('Intent Group') }}
              </v-tab>
              <v-tab-item :key="0">
                <div class="pa-2">
                  <v-layout wrap>
                    <v-flex xs6>
                      <div class="form-control" :class="{ 'has-error': errors.has('emo_class') }">
                        <label>emo_class</label>
                        <multiselect
                          v-model="intent.emo_class"
                          :options="healthOption.emo_class"
                          selectLabel
                          selectedLabel
                          :searchable="false"
                          deselect-label
                          data-vv-as="emo_class"
                          data-vv-name="emo_class"
                          name="emo_class"
                        ></multiselect>
                        <span class="text-error" v-show="errors.has('emo_class')">{{
                          errors.first('emo_class')
                        }}</span>
                      </div>
                    </v-flex>
                    <v-flex xs6 class="pl-2">
                      <div class="form-control" :class="{ 'has-error': errors.has('intent') }">
                        <label>intent</label>
                        <multiselect
                          v-model="intent.intent"
                          :options="healthOption.intent"
                          selectLabel
                          selectedLabel
                          :searchable="false"
                          deselect-label
                          data-vv-as="intent"
                          data-vv-name="intent"
                          name="intent"
                        ></multiselect>
                        <span class="text-error" v-show="errors.has('intent')">{{
                          errors.first('intent')
                        }}</span>
                      </div>
                    </v-flex>
                    <v-flex xs6>
                      <div class="form-control" :class="{ 'has-error': errors.has('topic') }">
                        <label>topic</label>
                        <multiselect
                          v-model="intent.topic"
                          :options="healthOption.topic"
                          selectLabel
                          selectedLabel
                          :searchable="false"
                          deselect-label
                          data-vv-as="topic"
                          data-vv-name="topic"
                          name="topic"
                        ></multiselect>
                        <span class="text-error" v-show="errors.has('topic')">{{
                          errors.first('topic')
                        }}</span>
                      </div>
                    </v-flex>
                    <v-flex xs6 class="pl-2">
                      <div class="form-control" :class="{ 'has-error': errors.has('keyword_vec') }">
                        <label>keyword_vec</label>
                        <input
                          type="text"
                          v-model="intent.keyword_vec"
                          data-vv-as="keyword_vec"
                          data-vv-name="keyword_vec"
                          name="keyword_vec"
                        />
                        <span class="text-error" v-show="errors.has('keyword_vec')">{{
                          errors.first('keyword_vec')
                        }}</span>
                      </div>
                    </v-flex>

                    <v-flex xs6>
                      <div class="form-control" :class="{ 'has-error': errors.has('similarity') }">
                        <label>similarity</label>
                        <input
                          type="number"
                          v-decimal.unsigned
                          v-model.number="intent.similarity"
                          data-vv-as="similarity"
                          data-vv-name="similarity"
                          name="similarity"
                        />
                        <span class="text-error" v-show="errors.has('similarity')">{{
                          errors.first('similarity')
                        }}</span>
                      </div>
                    </v-flex>
                    <v-flex xs6 class="pl-2">
                      <div class="form-control" :class="{ 'has-error': errors.has('review') }">
                        <label>review</label>
                        <v-switch
                          v-model="intent.review"
                          data-vv-as="review"
                          data-vv-name="review"
                          name="review"
                        ></v-switch>
                        <span class="text-error" v-show="errors.has('review')">{{
                          errors.first('review')
                        }}</span>
                      </div>
                    </v-flex>
                    <v-flex xs6>
                      <div class="form-control" :class="{ 'has-error': errors.has('seven_emo') }">
                        <label>seven_emo</label>
                        <multiselect
                          v-model="intent.seven_emo"
                          :options="healthOption.seven_emo"
                          selectLabel
                          selectedLabel
                          :searchable="false"
                          deselect-label
                          data-vv-as="seven_emo"
                          data-vv-name="seven_emo"
                          name="seven_emo"
                        ></multiselect>
                        <span class="text-error" v-show="errors.has('seven_emo')">{{
                          errors.first('seven_emo')
                        }}</span>
                      </div>
                    </v-flex>
                  </v-layout>
                </div>
              </v-tab-item>
              <v-tab-item :key="1">
                <v-card
                  flat
                  :style="{
                    'min-height':
                      $store.getters.getPackage != 'premium' || isCoachlab ? '250px' : '',
                  }"
                >
                  <v-premium-plan-popup
                    :showAll="false"
                    v-if="$store.getters.getPackage != 'premium' || isCoachlab"
                  ></v-premium-plan-popup>
                  <v-card-text>
                    <div class="form-control">
                      <div class="primary--text caption">{{ $t('Status') }}</div>
                      <input
                        type="text"
                        class="form-control"
                        :placeholder="$t('Status')"
                        v-model="intent.userstatus"
                        maxlength="600"
                      />
                    </div>
                    <div>
                      <div class="primary--text caption mb-2">{{ $t('Tag') }}</div>
                      <tags
                        v-model="usertag"
                        :tags="usertags"
                        @tags-changed="addUserTags"
                        @before-adding-tag="checkUserTags"
                        style="margin-bottom: 5px"
                        :btnText="$t('Add tag')"
                      ></tags>
                      <div class="caption">
                        {{ $t('Learn more') }}
                        <a
                          href="https://blog.zwiz.ai/%e0%b8%81%e0%b8%b2%e0%b8%a3%e0%b8%95%e0%b8%b4%e0%b8%94%e0%b8%aa%e0%b8%96%e0%b8%b2%e0%b8%99%e0%b8%b0status-%e0%b8%9b%e0%b9%89%e0%b8%b2%e0%b8%a2%e0%b8%81%e0%b8%b3%e0%b8%81%e0%b8%b1%e0%b8%9atag/"
                          target="_blank"
                          rel="noopener noreferrer"
                          >{{ $t('click here') }}</a
                        >
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item v-if="!isCommentToInbox && !isLiveStream" :key="2">
                <v-card
                  flat
                  :style="{
                    'min-height':
                      $store.getters.getPackage != 'premium' || isCoachlab ? '250px' : '',
                  }"
                >
                  <v-premium-plan-popup
                    :showAll="false"
                    v-if="$store.getters.getPackage != 'premium' || isCoachlab"
                  ></v-premium-plan-popup>
                  <v-card-text>
                    <v-layout>
                      <v-flex
                        class="form-control pr-1"
                        :class="{ 'has-error': errors.has('context_in') }"
                      >
                        <template v-if="isLiveStream">
                          <input
                            type="text"
                            class="form-control"
                            :value="$t('facebooklive')"
                            readonly
                            disabled
                          />
                        </template>
                        <template v-else-if="isCommentToInbox">
                          <input
                            type="text"
                            class="form-control"
                            :value="$t('Comment')"
                            readonly
                            disabled
                          />
                        </template>
                        <template v-else>
                          <input
                            style="margin-bottom: 5px"
                            type="text"
                            class="form-control"
                            placeholder="Context In"
                            data-vv-as="Context In"
                            name="context_in"
                            v-model="intent.context_in"
                            v-validate="!isCommentToInbox ? 'excluded:comment' : ''"
                          />
                          <span class="text-error" v-show="errors.has('context_in')">{{
                            $t('Context In cannot be Comment')
                          }}</span>
                        </template>
                      </v-flex>
                      <v-flex class="form-control pl-1">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Context Out"
                          v-model="intent.context_out"
                        />
                      </v-flex>
                    </v-layout>
                    <div class="caption">
                      {{ $t('Learn more') }}
                      <a
                        href="https://blog.zwiz.ai/%e0%b8%81%e0%b8%b2%e0%b8%a3%e0%b9%83%e0%b8%8a%e0%b9%89-context/"
                        target="_blank"
                        rel="noopener noreferrer"
                        >{{ $t('click here') }}</a
                      >
                    </div>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item :key="3">
                <v-card
                  flat
                  :style="{
                    'min-height':
                      $store.getters.getPackage != 'premium' || isCoachlab ? '250px' : '',
                  }"
                >
                  <v-premium-plan-popup
                    :showAll="false"
                    v-if="$store.getters.getPackage != 'premium' || isCoachlab"
                  ></v-premium-plan-popup>
                  <v-card-text>
                    <v-radio-group @change="changeOnlytime" v-model="intent.onlytime">
                      <v-radio
                        :color="'primary'"
                        :label="$t(`Turn On/Off Date & Time Setting for Bot's Reply`)"
                        :value="false"
                      ></v-radio>
                      <v-radio
                        :color="'primary'"
                        :label="$t(`Selecting certain chatbot's answers for the certain time`)"
                        :value="true"
                      ></v-radio>
                    </v-radio-group>
                    <v-layout v-if="intent.onlytime">
                      <v-flex class="pr-1">
                        <div class="form-control">
                          <div class="caption">{{ $t('Turn-on Time') }}</div>
                          <v-layout wrap>
                            <v-flex xs10 class="pl-1">
                              <v-menu
                                ref="openStartTime"
                                v-model="openStartTime"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                :return-value.sync="startTime"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                max-width="290px"
                                min-width="290px"
                              >
                                <template v-slot:activator="{ on }">
                                  <input
                                    type="text"
                                    class="form-control browser-default"
                                    :placeholder="$t('Time')"
                                    readonly
                                    v-model="startTime"
                                    v-on="on"
                                  />
                                </template>
                                <v-time-picker
                                  v-if="openStartTime"
                                  v-model="startTime"
                                  full-width
                                  @click:minute="$refs.openStartTime.save(startTime)"
                                ></v-time-picker>
                              </v-menu>
                            </v-flex>
                            <v-flex xs2>
                              <v-btn
                                fab
                                flat
                                small
                                color="primary"
                                style="height: 35px; width: 35px"
                                @click="
                                  startDate = null
                                  startTime = null
                                "
                              >
                                <v-icon>delete</v-icon>
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </div>
                      </v-flex>
                      <v-flex class="pl-1">
                        <div class="form-control">
                          <div class="caption">{{ $t('Turn-off Time') }}</div>
                          <v-layout wrap>
                            <v-flex xs10 class="pl-1">
                              <v-menu
                                ref="openEndTime"
                                v-model="openEndTime"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                :return-value.sync="endTime"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                max-width="290px"
                                min-width="290px"
                              >
                                <template v-slot:activator="{ on }">
                                  <input
                                    type="text"
                                    class="form-control browser-default"
                                    :placeholder="$t('Time')"
                                    readonly
                                    v-model="endTime"
                                    v-on="on"
                                  />
                                </template>
                                <v-time-picker
                                  v-if="openEndTime"
                                  v-model="endTime"
                                  full-width
                                  @click:minute="$refs.openEndTime.save(endTime)"
                                ></v-time-picker>
                              </v-menu>
                            </v-flex>
                            <v-flex xs2>
                              <v-btn
                                fab
                                flat
                                small
                                color="primary"
                                style="height: 35px; width: 35px"
                                @click="
                                  endDate = null
                                  endTime = null
                                "
                              >
                                <v-icon>delete</v-icon>
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </div>
                      </v-flex>
                    </v-layout>
                    <v-layout v-else>
                      <v-flex class="pr-1">
                        <div class="form-control">
                          <div class="caption">{{ $t('Turn-on Time') }}</div>
                          <v-layout wrap>
                            <v-flex
                              xs6
                              class="form-control"
                              :class="{ 'has-error': errors.has('startdate') }"
                            >
                              <v-menu
                                ref="openStartDate"
                                v-model="openStartDate"
                                :close-on-content-click="false"
                                full-width
                                max-width="290px"
                                color="primary"
                              >
                                <template v-slot:activator="{ on }">
                                  <input
                                    type="text"
                                    class="form-control browser-default"
                                    :placeholder="$t('Date')"
                                    readonly
                                    v-model="startDate"
                                    v-on="on"
                                    clearable
                                  />
                                </template>
                                <v-date-picker
                                  color="primary"
                                  v-model="startDate"
                                  @input="openStartDate = false"
                                ></v-date-picker>
                              </v-menu>
                            </v-flex>
                            <v-flex xs4 class="pl-1">
                              <v-menu
                                ref="openStartTime"
                                v-model="openStartTime"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                :return-value.sync="startTime"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                max-width="290px"
                                min-width="290px"
                                :disabled="startDate == null"
                              >
                                <template v-slot:activator="{ on }">
                                  <input
                                    type="text"
                                    class="form-control browser-default"
                                    :placeholder="$t('Time')"
                                    readonly
                                    v-model="startTime"
                                    v-on="on"
                                    :disabled="startDate == null"
                                  />
                                </template>
                                <v-time-picker
                                  v-if="openStartTime"
                                  v-model="startTime"
                                  full-width
                                  @click:minute="$refs.openStartTime.save(startTime)"
                                ></v-time-picker>
                              </v-menu>
                            </v-flex>
                            <v-flex xs2>
                              <v-btn
                                fab
                                flat
                                small
                                color="primary"
                                style="height: 35px; width: 35px"
                                @click="
                                  startDate = null
                                  startTime = null
                                "
                              >
                                <v-icon>delete</v-icon>
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </div>
                      </v-flex>
                      <v-flex class="pl-1">
                        <div class="form-control">
                          <div class="caption">{{ $t('Turn-off Time') }}</div>
                          <v-layout wrap>
                            <v-flex
                              class="form-control"
                              xs6
                              :class="{ 'has-error': errors.has('enddate') }"
                            >
                              <v-menu
                                ref="openEndDate"
                                v-model="openEndDate"
                                :close-on-content-click="false"
                                full-width
                                max-width="290px"
                                color="primary"
                              >
                                <template v-slot:activator="{ on }">
                                  <input
                                    type="text"
                                    class="form-control browser-default"
                                    :placeholder="$t('Date')"
                                    readonly
                                    v-model="endDate"
                                    v-on="on"
                                    clearable
                                  />
                                </template>
                                <v-date-picker
                                  color="primary"
                                  v-model="endDate"
                                  @input="openEndDate = false"
                                ></v-date-picker>
                              </v-menu>
                            </v-flex>
                            <v-flex xs4 class="pl-1">
                              <v-menu
                                ref="openEndTime"
                                v-model="openEndTime"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                :return-value.sync="endTime"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                max-width="290px"
                                min-width="290px"
                                :disabled="endDate == null"
                              >
                                <template v-slot:activator="{ on }">
                                  <input
                                    type="text"
                                    class="form-control browser-default"
                                    :placeholder="$t('Time')"
                                    readonly
                                    v-model="endTime"
                                    v-on="on"
                                    :disabled="endDate == null"
                                  />
                                </template>
                                <v-time-picker
                                  v-if="openEndTime"
                                  v-model="endTime"
                                  full-width
                                  @click:minute="$refs.openEndTime.save(endTime)"
                                ></v-time-picker>
                              </v-menu>
                            </v-flex>
                            <v-flex xs2>
                              <v-btn
                                fab
                                flat
                                small
                                color="primary"
                                style="height: 35px; width: 35px"
                                @click="
                                  endDate = null
                                  endTime = null
                                "
                              >
                                <v-icon>delete</v-icon>
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </div>
                      </v-flex>
                    </v-layout>

                    <div class="form-control" :class="{ 'has-error': errors.has('startdate') }">
                      <input
                        v-model="startTimeFormat"
                        type="hidden"
                        :data-vv-as="$t('Start date')"
                        name="startdate"
                        v-validate="endTimeFormat ? '' : ''"
                      />
                      <input
                        :data-vv-as="$t('End date')"
                        name="enddate"
                        v-model="endTimeFormat"
                        type="hidden"
                        ref="beforeTarget"
                      />

                      <span class="text-error" v-if="errors.has('startdate')">
                        {{ errors.first('startdate') }}
                      </span>
                    </div>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item :key="4">
                <v-card
                  flat
                  :style="{ 'min-height': $store.getters.getPackage != 'premium' ? '250px' : '' }"
                >
                  <v-premium-plan-popup
                    :showAll="false"
                    v-if="$store.getters.getPackage != 'premium'"
                  ></v-premium-plan-popup>
                  <v-card-text>
                    <div class="col s8">
                      <div class="primary--text caption">{{ $t('Line Notify') }}</div>
                    </div>
                    <div class="col s4 right-align">
                      <template v-if="$store.state.linenotifylist.length == 0"></template>
                      <template
                        v-else-if="
                          (selectedBot.notify_intent && !isCommentToInbox) ||
                          (selectedBot.notify_comment && isCommentToInbox)
                        "
                      >
                        <label
                          class="toggle-switch small"
                          style="margin-top: 10px; margin-bottom: 10px; vertical-align: bottom"
                        >
                          <input
                            type="checkbox"
                            :checked="intent.linenoti_status"
                            @change="toggleLineNotifyStatus"
                          />
                          <span class="toggle-slider lever round"></span>
                        </label>
                      </template>
                    </div>
                    <div class="col s12 form-control">
                      <template v-if="$store.state.linenotifylist.length == 0">
                        {{ $t('You are not connected to Line Notify.') }}
                        <router-link to="billing">{{
                          $t('Click to connected Line Notify at the settings page')
                        }}</router-link>
                      </template>
                      <template
                        v-else-if="
                          (selectedBot.notify_intent && !isCommentToInbox) ||
                          (selectedBot.notify_comment && isCommentToInbox)
                        "
                      >
                        <input
                          type="text"
                          class="form-control"
                          :placeholder="$t('Message')"
                          maxlength="250"
                          v-model="intent.linenoti_text"
                        />
                      </template>
                      <template v-else>
                        {{ $t('Not yet alert via Line Notify.') }}
                        <router-link to="billing">{{
                          $t('Click to connected Line Notify at the settings page')
                        }}</router-link>
                      </template>
                    </div>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item :key="5">
                <v-card v-if="advancedTab && advancedTab == 4" flat>
                  <v-card-text>
                    <template v-if="selectedBot.theme == 'ticket'">
                      <div>
                        <v-layout row wrap>
                          <v-flex
                            xs12
                            sm6
                            class="form-control px-1 pb-2"
                            :class="{ 'has-error': errors.has('group') }"
                          >
                            <div class="caption mb-1 mt-2">Group *</div>
                            <multiselect
                              v-model="ticket.group"
                              :options="agentGroup"
                              track-by="groupname"
                              label="groupname"
                              name="group"
                              :searchable="true"
                              selectLabel
                              selectedLabel
                              deselect-label
                              @input="onChangeGroup"
                            ></multiselect>
                            <p class="text-error" v-if="errors.has('group')">
                              {{ errors.first('group') }}
                            </p>
                          </v-flex>
                          <v-flex xs12 sm6 class="form-control px-1 pb-2" v-if="ticket.group">
                            <div class="caption mb-1 mt-2">Subgroup</div>
                            <v-layout>
                              <multiselect
                                v-model="ticket.subgroup"
                                :options="filterSubGroup"
                                track-by="subgroupname"
                                label="subgroupname"
                                :searchable="true"
                                selectLabel
                                selectedLabel
                                deselect-label
                              ></multiselect>
                              <v-btn small flat fab class="my-0" @click="ticket.subgroup = null">
                                <v-icon>close</v-icon>
                              </v-btn>
                            </v-layout>
                          </v-flex>
                          <v-flex xs12 sm6>
                            <div class="caption mb-1 mt-2">Priority *</div>
                            <multiselect
                              class="mb-3"
                              v-model="ticket.priority"
                              :key="`priority`"
                              :options="priorityOptions"
                              label="text"
                              selectLabel
                              selectedLabel
                              :allow-empty="false"
                              :searchable="false"
                              deselect-label
                              track-by="text"
                            ></multiselect>
                          </v-flex>
                          <v-flex xs12>
                            <div class="caption mb-1 mt-2">Tags</div>
                            <v-combobox
                              v-model="ticket.tags"
                              :filter="tagsfilter"
                              :hide-no-data="!tagssearch"
                              :items="tagitems"
                              :search-input.sync="tagssearch"
                              hide-selected
                              label="Search for an option"
                              multiple
                              small-chips
                              solo
                            >
                              <template v-slot:no-data>
                                <v-list-tile>
                                  <span class="subheading">Create</span>
                                  <v-chip :color="`primary lighten-3`" label small>{{
                                    tagssearch
                                  }}</v-chip>
                                </v-list-tile>
                              </template>
                              <template v-slot:selection="{ item, parent, selected }">
                                <v-chip
                                  v-if="item === Object(item)"
                                  :color="`primary lighten-3`"
                                  :selected="selected"
                                  label
                                  small
                                >
                                  <span class="pr-2">{{ item.text }}</span>
                                  <v-icon small @click="parent.selectItem(item)">close</v-icon>
                                </v-chip>
                              </template>
                              <template v-slot:item="{ index, item }">
                                <v-list-tile-content>
                                  <v-text-field
                                    v-if="tagediting === item"
                                    v-model="tagediting.text"
                                    autofocus
                                    flat
                                    background-color="transparent"
                                    hide-details
                                    solo
                                    @keyup.enter="tagsedit(index, item)"
                                  ></v-text-field>
                                  <v-chip v-else :color="`primary lighten-3`" dark label small>{{
                                    item.text
                                  }}</v-chip>
                                </v-list-tile-content>
                                <v-spacer></v-spacer>
                                <v-list-tile-action @click.stop>
                                  <v-btn icon @click.stop.prevent="tagsedit(index, item)">
                                    <v-icon>{{ tagediting !== item ? 'edit' : 'check' }}</v-icon>
                                  </v-btn>
                                </v-list-tile-action>
                              </template>
                            </v-combobox>
                          </v-flex>
                        </v-layout>
                        <v-layout wrap>
                          <v-flex xs7 class="px-1 form-control">
                            <div class="caption">Due Date</div>

                            <datepicker
                              color="primary"
                              v-model="ticket.duedate.start"
                              @selected="onSelectedDueDate"
                            ></datepicker>
                          </v-flex>
                          <v-flex xs4 class="px-1 form-control">
                            <div class="caption">Start Time</div>
                            <v-dialog
                              ref="starttime"
                              v-model="showDueTimeDialog"
                              :return-value.sync="ticket.duedate.starttime"
                              persistent
                              lazy
                              full-width
                              width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-layout>
                                  <input
                                    type="text"
                                    readonly
                                    v-on="on"
                                    placeholder="00:00"
                                    v-model="ticket.duedate.starttime"
                                    :disabled="!ticket.duedate.start"
                                  />
                                </v-layout>
                              </template>
                              <v-time-picker
                                v-if="showDueTimeDialog"
                                v-model="ticket.duedate.starttime"
                                full-width
                              >
                                <v-spacer></v-spacer>
                                <v-btn flat color="primary" @click="showDueTimeDialog = false">{{
                                  $t('cancel')
                                }}</v-btn>
                                <v-btn
                                  flat
                                  color="primary"
                                  @click="
                                    $refs.starttime.save(ticket.duedate.starttime)
                                    showDueTimeDialog = false
                                  "
                                  >{{ $t('Confirm') }}</v-btn
                                >
                              </v-time-picker>
                            </v-dialog>
                          </v-flex>
                          <v-flex xs1>
                            <div class="caption">&nbsp;</div>
                            <v-btn
                              fab
                              flat
                              small
                              @click="
                                ticket.duedate.starttime = null
                                ticket.duedate.start = null
                              "
                            >
                              <v-icon>close</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </div>
                    </template>
                    <template v-else>
                      <div>
                        <div class="form-control">
                          <div class="primary--text caption">{{ $t('Intent Group') }}</div>
                          <input
                            type="text"
                            class="form-control"
                            :placeholder="$t('Intent Group')"
                            v-model="intent.intentgroup"
                            maxlength="600"
                          />
                        </div>
                      </div>
                    </template>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </div>
        </template>
      </div>

      <div class="text-xs-center" style="margin-top: 35px; margin-bottom: 15px">
        <template>
          <input
            type="hidden"
            v-model="intent.q_val"
            v-validate="
              !['{default}', '{default_comment_to_inbox}'].includes(intent.intentname)
                ? 'required'
                : ''
            "
            :data-vv-as="$t('customer says')"
            name="q_val"
          />
          <div class="form-control has-error" style="margin-bottom: 10px">
            <span class="text-error" v-if="errors.has('intentName')">{{
              errors.first('intentName')
            }}</span>
            <span class="text-error" v-else-if="errors.has('q_val')">{{
              errors.first('q_val')
            }}</span>
            <span class="text-error" v-else-if="errors.has('bubbleLimit')">{{
              errors.first('bubbleLimit')
            }}</span>
            <span class="text-error" v-else-if="errorTag.length > 0">
              <template v-if="errorTag.includes('overmaxlength')">{{
                $t('Message cannot be longer than 20 alphabets')
              }}</template>
              <template v-else-if="errorTag.includes('overtagmax')">{{
                $t('Choices cannot be more than 10 items')
              }}</template>
              <template v-else-if="errorTag.includes('duplicate')">{{
                $t('Duplicate Choice')
              }}</template>
            </span>
            <span class="text-error" v-else-if="errors.has('context_in')">{{
              $t('Context In cannot be Comment')
            }}</span>
            <span class="text-error" v-else-if="errors.has('startdate')">{{
              errors.first('startdate')
            }}</span>
          </div>
          <slot name="footer" :saveIntent="saveIntent" :cancelEdit="cancelEdit">
            <div style="margin-bottom: 15px">
              <a href="javascript:void(0);" class="btn-preview" @click="showPreview = true">
                <i class="far fa-eye"></i>
                {{ $t('preview') }}
              </a>
              <preview-message
                v-if="showPreview"
                @close="showPreview = false"
                :messages="messages"
                :choice="replies"
                :questions="questions"
                :isComment="isCommentToInbox"
                :comment="replyComment"
              ></preview-message>
            </div>
            <v-btn outline color="grey" @click="cancelEdit">{{ $t('cancel') }}</v-btn>
            <v-btn depressed color="primary" @click="saveIntent">{{ $t('Save') }}</v-btn>
          </slot>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import VueTagsInput from '@johmun/vue-tags-input'
import uploadfile from '@/components/elements/uploadfile'
import IntentGroup from './IntentGroup'
import IntentComment from './IntentComment'
import IntentGetstarted from './IntentGetstarted'
import Draggable from 'vuedraggable'
import GenericManage from '@/components/elements/GenericManage'
import MoveHorizontal from '@/components/elements/MoveHorizontal'
import AutoresizeTextarea from '@/components/elements/AutoresizeTextarea'
import IntentPrefill from './IntentPrefill'

import ModalDialog from '@/components/elements/ModalDialog'
import ModalBlank from '@/components/elements/ModalBlank'
import Tags from '@/components/elements/Tags'
import ViewCartSummaryViewer from '@/components/elements/ViewCartSummaryViewer'
import PreviewMessage from '@/components/elements/PreviewMessage'
import IntentSelectPost from './IntentSelectPost'
import IntentQuestion from './IntentQuestion'
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import datepicker from 'vuejs-datepicker'

import { VueAutosuggest } from 'vue-autosuggest'
import { ToggleButton } from 'vue-js-toggle-button'
import Label from '../../elements/label.vue'

const dict = {
  en: {
    custom: {
      intentName: {
        excluded: 'Duplicate Conversation Name',
        excludednew: 'Duplicate Conversation Name',
      },
    },
  },
  th: {
    custom: {
      intentName: {
        excluded: 'ชื่อบทสนทนาซ้ำ',
        excludednew: 'ชื่อบทสนทนาซ้ำ',
      },
    },
  },
  la: {
    custom: {
      intentName: {
        excluded: 'ເຮັດຊ້ໍາຊື່ການສົນທະນາ',
        excludednew: 'ເຮັດຊ້ໍາຊື່ການສົນທະນາ',
      },
    },
  },
}

export default {
  props: {
    value: {
      type: Object,
    },
    type: {
      type: String,
      default: 'add',
    },
    isDefault: {
      type: Boolean,
      default: false,
    },
    isWelcome: {
      type: Boolean,
      default: false,
    },
    excludedIntentName: {
      type: String,
      default: '',
    },
    isCommentToInbox: {
      type: Boolean,
      default: false,
    },
    isLiveStream: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    VueTagsInput,
    uploadfile,
    IntentGroup,
    IntentComment,
    IntentGetstarted,
    Draggable,
    GenericManage,
    MoveHorizontal,
    AutoresizeTextarea,
    IntentPrefill,

    ModalDialog,
    ModalBlank,
    Tags,
    PreviewMessage,
    ViewCartSummaryViewer,
    VueAutosuggest,
    IntentSelectPost,
    IntentQuestion,
    Multiselect,
    ToggleButton,
    datepicker,
    Label,
  },
  data: function () {
    return {
      tagssearch: null,
      showDueTimeDialog: false,
      priorityOptions: [
        {
          text: 'Low',
          value: 'low',
        },
        {
          text: 'Medium',
          value: 'medium',
        },
        {
          text: 'High',
          value: 'high',
        },
      ],
      tagediting: null,
      postidlist: { includes: [], excludes: [] },
      advancedTab: null,
      showSelectPost: false,
      showAdvanced: false,
      showPreview: false,
      intent: undefined,

      startDate: null,
      startTime: null,
      openStartDate: false,
      openStartTime: false,
      endDate: null,
      endTime: null,
      openEndDate: false,
      openEndTime: false,

      tag: '',
      usertag: '',
      groups: [],
      generics: [],
      quick_reply: '',
      reply: '',
      text: '',
      messages: [[]],

      errorTag: [],
      errorQuestionTag: [],

      isReplyComment: false,
      replyComment: '',
      showEmoji: false,
      excludedName: '',
      intents: [],

      selected: '',
      filteredOptions: [],
      inputProps: {
        id: 'autosuggest__input',
        onInputChange: this.onInputChange,
        placeholder: "Type 'e'",
      },
      healthOption: {
        emo_class: ['', 'neg_ac', 'neg_de', 'pos_ac', 'pos_de'],
        intent: ['', 'chitchat', 'greet', 'bye', 'affirm', 'question'],
        topic: ['', 'love', 'family', 'work', 'money', 'health', 'friend', 'study', 'general'],
        seven_emo: ['', 'happy', 'relaxed', 'angry', 'stressed', 'depressed', 'bored', 'neural'],
      },
      ticket: {
        assigngroupid: '',
        assignsubgroupid: '',
        priority: '',
        group: '',
        subgroup: '',
        tags: [],
        duedate: {
          start: '',
          starttime: '',
          end: '',
        },
      },
      tagitems: [{ header: 'Select an option or create one' }],
      limit: 10,
      showDueDate: false,
    }
  },
  created: function () {
    var vm = this
    vm.$validator.extend('earlier', {
      getMessage(field, val) {
        return vm.$t('The {field} must be before or equal.', { field: field })
      },
      validate(value, field) {
        if (vm.startTimeFormat || vm.endTimeFormat) {
          var isafter = moment(vm.startTimeFormat).isAfter(vm.endTimeFormat)
          return !isafter
        } else {
          return true
        }
      },
    })
  },
  mounted: function () {
    let vm = this

    vm.$validator.localize(dict)
    vm.$validator.localize(this.currentLang)

    vm.intent = Object.assign({}, vm.value)
    if (!vm.intent.postidlist) {
      vm.intent.postidlist = ''
    } else {
      var includes = []
      if (vm.intent.postidlist && vm.intent.postidlist !== '') {
        try {
          includes = JSON.parse(vm.intent.postidlist)
        } catch (error) {
          includes = vm.intent.postidlist.split(',')
        }
      }
      this.$set(this.postidlist, 'includes', includes)
    }

    if (!vm.intent.exceptpostidlist) {
      vm.intent.exceptpostidlist = ''
    } else {
      var excludes = []
      if (vm.intent.exceptpostidlist && vm.intent.exceptpostidlist !== '') {
        try {
          excludes = JSON.parse(vm.intent.exceptpostidlist)
        } catch (error) {
          excludes = vm.intent.exceptpostidlist.split(',')
        }
      }
      this.$set(this.postidlist, 'excludes', excludes)
    }
    vm.cached_intent = Object.assign({}, vm.value)

    if (vm.intent.starttime) {
      var startTime = moment(vm.intent.starttime)
      vm.startDate = startTime.format('YYYY-MM-DD')
      vm.startTime = startTime.format('HH:mm')
    }
    if (vm.intent.endtime) {
      var endTime = moment(vm.intent.endtime)
      vm.endDate = endTime.format('YYYY-MM-DD')
      vm.endTime = endTime.format('HH:mm')
    }

    vm.intents = vm.excludedIntentName.split(',')
    vm.intents.push('comment')
    vm.intents.push('{default}')
    vm.intents.push('{welcome}')
    vm.intents.push('{default_comment_to_inbox}')

    vm.intent.onlytime = vm.intent.onlytime ? vm.intent.onlytime : false

    if (vm.isCommentToInbox && !vm.isLiveStream) {
      vm.isReplyComment = true
      vm.intent.context_in = 'comment'
    } else if (vm.isLiveStream) {
      vm.intent.context_in = 'facebooklive'
    }
    var names = []
    if (vm.type === 'edit' && vm.excludedIntentName && vm.excludedIntentName !== '' && vm.intent) {
      names = vm.intents
      $.each(names, function (index, name) {
        if (name === vm.intent.intentname) {
          names.splice(index, 1)
          return false
        }
      })

      names = names.map((el) => {
        return el.replace(/,/g, '')
      })

      vm.excludedName = names.join(',').replace(/[|]/g, '//#or//')
    } else {
      names = vm.intents.map((el) => {
        return el.replace(/,/g, '')
      })

      vm.excludedName = names.join(',').replace(/[|]/g, '//#or//')
    }

    if (vm.value.context_in === 'comment') {
      if (vm.value.a_type === 'json') {
        if (vm.isJsonParseable(vm.value.a_val)) {
          var message = JSON.parse(vm.value.a_val)
          if (message[0][0].type === 'text') {
            vm.messages = [
              [
                {
                  type: 'responsepost',
                  replyinbox: true,
                  replycomment: false,
                  hidecomment: false,
                  responseinbox: [
                    {
                      type: 'text',
                      text: message[0][0].text,
                    },
                  ],
                  responsecomment: [
                    {
                      type: 'text',
                      text: '',
                    },
                  ],
                },
              ],
            ]
          } else if (message[0][0].type === 'responsepost') {
            vm.messages = message
          }
        } else {
          vm.messages = [
            [
              {
                type: 'responsepost',
                replyinbox: true,
                replycomment: false,
                hidecomment: false,
                responseinbox: [
                  {
                    type: 'text',
                    text: vm.value.a_val,
                  },
                ],
                responsecomment: [
                  {
                    type: 'text',
                    text: '',
                  },
                ],
              },
            ],
          ]
        }
      } else {
        vm.messages = [
          [
            {
              type: 'responsepost',
              replyinbox: true,
              replycomment: false,
              hidecomment: false,
              responseinbox: [
                {
                  type: 'text',
                  text: vm.value.a_val,
                },
              ],
              responsecomment: [
                {
                  type: 'text',
                  text: '',
                },
              ],
            },
          ],
        ]
      }
    } else if (vm.value.a_type === 'json') {
      if (vm.isJsonParseable(vm.value.a_val)) {
        vm.messages = JSON.parse(vm.value.a_val)
      } else {
        vm.messages = [[]]
      }
    } else {
      if (vm.value.a_val === '{welcome_message}') {
        vm.messages = [
          [
            {
              type: 'welcome_message',
            },
          ],
        ]
      } else if (vm.value.a_type === 'text') {
        var newGroup = []
        var group = vm.value.a_val.split('||')
        $.each(group, function (index, messages) {
          var newMessage = []
          var groupMessages = messages.split('#nl')
          $.each(groupMessages, function (index, message) {
            var type = 'text'
            if (!isNaN(message)) {
              newMessage.push({
                type: 'text',
                text: message,
              })
            } else if (vm.isJsonParseable(message)) {
              var messageParsed = JSON.parse(message)
              newMessage.push({
                text: messageParsed.text,
                buttons: messageParsed.buttons,
                type: 'button',
              })
            } else if (vm.isURL(message)) {
              newMessage.push({
                type: 'image',
                image_url: message,
              })
            } else {
              newMessage.push({
                type: 'text',
                text: message,
              })
            }
          })
          newGroup.push(newMessage)
        })
        vm.messages = newGroup
      } else if (vm.value.a_type === 'message') {
        vm.messages = [
          [
            {
              type: 'text',
              data: vm.value.a_val,
            },
          ],
        ]
      } else if (vm.value.a_type === 'template') {
        vm.messages = [
          [
            {
              type: 'generic',
              data: JSON.parse(vm.value.a_val),
              ratio: vm.value.ratio == 'horizontal' ? 'horizontal' : 'square',
            },
          ],
        ]
      } else if (vm.value.a_type === 'message') {
      } else if (vm.value.a_type === 'generic') {
      } else if (vm.value.a_type === 'viewsummary') {
        vm.messages = [
          [
            {
              type: 'text',
              text: '{viewsummary}',
            },
          ],
        ]
      }
    }
    if (this.selectedBot.theme == 'ticket') {
      try {
        try {
          var ticket = JSON.parse(this.intent.intentgroup)
        } catch (error) {
          console.log(error)
        }
        this.ticket = Object.assign(this.ticket, {
          group: ticket.assigngroupid
            ? this.agentGroup.find((el) => el.id == ticket.assigngroupid)
            : '',
          subgroup: ticket.assignsubgroupid
            ? this.agentSubGroup.find((el) => el.id == ticket.assignsubgroupid)
            : '',
          priority: ticket.priority
            ? this.priorityOptions.find((el) => el.value == ticket.priority)
            : '',
          tags: ticket.tags
            ? ticket.tags.split(',').map((el) => {
                return { text: el }
              })
            : [],
        })
        if (ticket.duedate) {
          this.ticket.duedate = {
            start: moment(this.ticket.duedate).format('YYYY-MM-DD'),
            starttime: moment(this.ticket.duedate).format('HH:mm'),
            end: '',
          }
        }
      } catch (error) {
        console.log(error)
      }
    }
  },
  computed: {
    tickettags() {
      return this.ticket.tags
    },
    filterSubGroup() {
      if (this.ticket.group) {
        return this.agentSubGroup.filter((el) => {
          return el.admingroupid == this.ticket.group.id
        })
      } else {
        return []
      }
    },
    showReplyCommentSelectPost() {
      return this.isReplyComment && this.isCommentToInbox && !this.isLiveStream
    },
    ...mapGetters({
      selectedBot: 'selectedBot',
      welcomeMessage: 'welcomeMessage',
      setting: 'setting',
      currentLang: 'currentLang',
      isCoachlab: 'isCoachlab',
      agentGroup: 'getAgentGroup',
      loadingAgentGroup: 'getLoadingAgentGroup',
      agentSubGroup: 'getAgentSubgroup',
      loadingAgentSubGroup: 'getLoadingAgentSubgroup',
    }),
    areaName: function () {
      var areaName = ['ทุกพื้นที่'].concat(this.$store.state.uuAreaName)
      return areaName
    },
    tags: {
      get() {
        let vm = this
        if (vm.intent && vm.intent.q_val && vm.intent.q_val !== '') {
          var tags = vm.intent.q_val.split(',')
          var result = []
          $.each(tags, function (index, val) {
            result.push({ text: val })
          })
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        $.each(value, function (index, val) {
          result.push(val.text)
        })
        vm.intent.q_val = result.join(',')
      },
    },
    replies: {
      get() {
        let vm = this
        if (vm.intent && vm.intent.quick_reply && vm.intent.quick_reply !== '') {
          // console.log(vm.intent.quick_reply)
          var quick_replies = []

          if (vm.value.a_type === 'message' || vm.value.a_type === 'generic') {
            if (vm.setting.welcome_quickreplies) {
              quick_replies = vm.setting.welcome_quickreplies.contentvalue.split(',')
            }
          } else {
            quick_replies = vm.intent.quick_reply.split(',')
          }
          var result = []
          $.each(quick_replies, function (index, val) {
            result.push({ text: val })
          })
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        $.each(value, function (index, val) {
          result.push(val.text)
        })
        vm.intent.quick_reply = result.join(',')
      },
    },
    usertags: {
      get() {
        let vm = this
        if (vm.intent && vm.intent.usertags && vm.intent.usertags !== '') {
          var usertags = []

          usertags = vm.intent.usertags.split(',')
          var result = []
          if (usertags) {
            usertags.map(function (tag, index) {
              result.push({ text: tag })
            })
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        if (value) {
          value.map(function (tag, index) {
            result.push(tag.text)
          })
        }
        vm.intent.usertags = result.join(',')
      },
    },
    questions: function () {
      var result = []
      $.each(this.tags, function (index, val) {
        result.push(val.text)
      })
      return result
    },

    startTimeFormat: function () {
      var time = null
      var vm = this
      if (this.intent.onlytime) {
        if (vm.startTime) time = moment().format('YYYY-MM-DD') + ' ' + vm.startTime + ':00'
        else time = moment().format('YYYY-MM-DD') + ' 00:00:00'
      } else if (vm.startDate) {
        if (vm.startTime) {
          time = vm.startDate + ' ' + vm.startTime + ':00'
        } else {
          time = vm.startDate + ' 00:00:00'
        }
      }
      return time
    },
    endTimeFormat: function () {
      var time = null
      var vm = this
      if (this.intent.onlytime) {
        if (vm.endTime) time = moment().format('YYYY-MM-DD') + ' ' + vm.endTime + ':00'
        else time = moment().format('YYYY-MM-DD') + ' 23:59:00'
      } else if (vm.endDate) {
        if (vm.endTime) {
          time = vm.endDate + ' ' + vm.endTime + ':00'
        } else {
          time = vm.endDate + ' 23:59:00'
        }
      }
      return time
    },
    intentgroup() {
      var hasValue = (val) => (val && val.length ? val : null)
      var duedate = null
      if (this.ticket.duedate.start) {
        duedate = moment(this.ticket.duedate.start).format('YYYY-MM-DD')
        if (this.ticket.duedate.starttime) {
          duedate = duedate + ' ' + this.ticket.duedate.starttime
        } else {
          duedate = duedate + ' 00:00'
        }
      }
      return {
        assigngroupid: hasValue(this.ticket.group.id),
        assignsubgroupid: hasValue(this.ticket.subgroup ? this.ticket.subgroup.id : null),
        priority: hasValue(this.ticket.priority.value),
        duedate: duedate,
        tags:
          this.ticket.tags && this.ticket.tags.length
            ? this.ticket.tags.map((el) => el.text).join(',')
            : null,
      }
    },
  },

  methods: {
    tagsedit(index, item) {
      if (!this.tagediting) {
        this.tagediting = item
        this.index = index
      } else {
        this.tagediting = null
        this.index = -1
      }
    },
    tagsfilter(item, queryText, itemText) {
      if (item.header) return false

      const hasValue = (val) => (val != null ? val : '')

      const text = hasValue(itemText)
      const query = hasValue(queryText)

      return text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) > -1
    },
    onSelectedDueDate: function (value) {
      var vm = this

      if (this.ticket.duedate.end && moment(this.ticket.duedate.end).isBefore(value)) {
        this.ticket.duedate.end = value
      }
      vm.ticket.duedate.start = value
      vm.showDueDate = false
    },
    async onChangeGroup(val) {
      this.ticket.subgroup = null
      this.ticket.assignedTo = null
    },
    saveFilterPost(payload) {
      this.$set(this.intent, 'postidlist', payload.includes)
      this.$set(this.intent, 'exceptpostidlist', payload.excludes)
      var includes = []
      var excludes = []
      if (payload.includes) {
        try {
          includes = JSON.parse(payload.includes)
        } catch (error) {
          includes = payload.includes.split(',')
        }
      }
      if (payload.excludes) {
        try {
          excludes = JSON.parse(payload.excludes)
        } catch (error) {
          excludes = payload.excludes.split(',')
        }
      }
      this.postidlist = { includes, excludes }
    },
    changeOnlytime(e) {
      this.$forceUpdate()
    },
    toggleLineNotifyStatus: function () {
      this.intent.linenoti_status = !this.intent.linenoti_status
    },
    onShowAdvance: function () {
      this.showAdvanced = !this.showAdvanced
    },
    addGeneric: function () {
      this.generics.push({
        image_url: null,
        title: '',
        subtitle: '',
        buttons: [],

        enable: true,
      })
    },
    saveIntent: function () {
      let vm = this
      let data = {
        pageid: vm.selectedBot.pageid,
        intentname: vm.intent.intentname,
        q_type: vm.intent.q_type,
        q_val: vm.intent.q_val,
        a_type: 'json',
        a_val: vm.intent.a_val,
        quick_reply: vm.intent.quick_reply,
        postidlist: vm.intent.postidlist,
        exceptpostidlist: vm.intent.exceptpostidlist ? vm.intent.exceptpostidlist : '',
        isShow: true,
        intentstatus: vm.intent.intentstatus ? vm.intent.intentstatus : false,
        onlytime: vm.intent.onlytime ? vm.intent.onlytime : false,
        intentgroup: vm.intent.intentgroup ? vm.intent.intentgroup : null,
        emo_class: vm.intent.emo_class ? vm.intent.emo_class : null,
        intent: vm.intent.intent ? vm.intent.intent : null,
        topic: vm.intent.topic ? vm.intent.topic : null,
        keyword_vec: vm.intent.keyword_vec ? vm.intent.keyword_vec : null,
        similarity: vm.intent.similarity ? vm.intent.similarity : null,
        review: vm.intent.review ? vm.intent.review : false,
        seven_emo: vm.intent.seven_emo ? vm.intent.seven_emo : null,
      }

      if (vm.selectedBot.theme == 'universalutilities') {
        if (vm.selectedBot.uu_areaname != '' && vm.selectedBot.uu_areaname != null) {
          data.intentgroup = vm.selectedBot.uu_areaname
        } else if (vm.selectedBot.uu_areaname == '' || vm.selectedBot.uu_areaname == null) {
          data.intentgroup = vm.intent.intentgroup == 'ทุกพื้นที่' ? '' : vm.intent.intentgroup
        }
      } else if (vm.selectedBot.theme == 'ticket') {
        data.intentgroup = vm.intentgroup
      }

      if (vm.$store.getters.getPackage == 'premium') {
        data.context_in = vm.intent.context_in != null ? vm.intent.context_in : ''
        data.context_out = vm.intent.context_out != null ? vm.intent.context_out : ''
        data.userstatus = vm.intent.userstatus
        data.usertags = vm.intent.usertags
        data.linenoti_status = vm.intent.linenoti_status
        data.linenoti_text = vm.intent.linenoti_text
        data.starttime = vm.startTimeFormat ? vm.startTimeFormat + moment().format('Z') : null
        data.endtime = vm.endTimeFormat ? vm.endTimeFormat + moment().format('Z') : null
      } else {
        data.context_in = vm.cached_intent.context_in != null ? vm.cached_intent.context_in : ''
        data.context_out = vm.cached_intent.context_out != null ? vm.cached_intent.context_out : ''
        data.userstatus = vm.cached_intent.userstatus
        data.usertags = vm.cached_intent.usertags
        data.linenoti_status = vm.cached_intent.linenoti_status
        data.linenoti_text = vm.cached_intent.linenoti_text
        data.starttime = vm.cached_intent.starttime ? vm.cached_intent.starttime : null
        data.endtime = vm.cached_intent.endtime ? vm.cached_intent.endtime : null
      }

      if (vm.isWelcome) {
        var welcome_answer = [
          [
            {
              type: 'welcome_message',
            },
          ],
        ]
        data.a_val = JSON.stringify(welcome_answer)
      } else {
        if (vm.isCommentToInbox && !vm.isLiveStream) {
          var message = []
          if (vm.messages) {
            message = vm.checkEmptyReplyMessage(vm.messages)
          }

          if (message.length === 0) {
            message.push([
              {
                type: 'responsepost',
                replyinbox: true,
                replycomment: false,
                hidecomment: false,
                responseinbox: [
                  {
                    type: 'text',
                    text: '',
                  },
                ],
                responsecomment: [
                  {
                    type: 'text',
                    text: '',
                  },
                ],
              },
            ])
          }
          data.a_val = JSON.stringify(message).replace(/ /gim, ' ')
          data.context_in = 'comment'
          data.a_type = 'json'
        } else if (vm.isLiveStream) {
          var message = []
          if (vm.messages) {
            message = vm.checkEmptyReplyMessage(vm.messages)
          }

          if (message.length === 0) {
            message.push([
              {
                type: 'responsepost',
                replyinbox: true,
                replycomment: false,
                hidecomment: false,
                responseinbox: [
                  {
                    type: 'text',
                    text: '',
                  },
                ],
                responsecomment: [
                  {
                    type: 'text',
                    text: '',
                  },
                ],
              },
            ])
          }
          data.a_val = JSON.stringify(message).replace(/ /gim, ' ')
          data.context_in = 'facebooklive'
          data.a_type = 'json'
        } else if (data.a_type === 'json') {
          var messages = vm.checkEmptyMessage(vm.messages)

          data.a_val = JSON.stringify(messages)
        }
      }
      vm.$validator
        .validateAll()
        .then((result) => {
          if (!result || vm.errorTag.length) {
            vm.goToErrorInput()
            // do stuff if not valid.
            // console.log(this.$validator.errors.items)
            return false
          }
          if (!vm.intent.id) {
            vm.$store.dispatch('loading')
            api.addIntent(data, function (error, response) {
              if (error) {
                console.error(error)
                vm.$store.dispatch('loading')
                return
              }
              data.id = response.id
              vm.$emit('input', data)
              vm.$emit('saveIntent', data)
              vm.$emit('close', null)
              vm.$store.dispatch('loading')
              vm.intent = {
                intentname: '',
                q_type: 'text',
                a_type: 'json',
                q_val: '',
                a_val: [[]],
                context_in: '',
                context_out: '',
                postidlist: '',
                exceptpostidlist: '',
              }
              vm.cached_intent = Object.assign({}, vm.intent)
            })
          } else {
            data['id'] = vm.intent.id
            vm.$store.dispatch('loading')
            api.editIntent(data, function (error, response) {
              if (error) {
                console.error(error)
                vm.$store.dispatch('loading')
                return
              }
              vm.$emit('input', data)
              // console.log(data)
              vm.$emit('saveIntent', data)
              vm.cached_intent = Object.assign({}, vm.intent)

              vm.$store.dispatch('loading')
            })
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    cancelEdit: function () {
      var vm = this
      vm.intent = Object.assign({}, vm.cached_intent)
      vm.$emit('close', null)
    },
    checkTag(obj) {
      this.errorQuestionTag = []
      if (obj.tag.text == '') {
      } else if (obj.tag.isDuplicate) {
        // this.replies.map(t => t.text).indexOf(obj.tag.text) !== -1s
        this.errorQuestionTag.push('duplicate')
        obj.error()
      } else obj.addTag()

      // if (obj.tag.text.includes(',')) alert('Letter "," is forbidden');
    },
    checkQuickReply(obj) {
      // if (obj.tag.text.includes(',')) alert('Letter "," is forbidden');
      // else

      this.errorTag = []
      if (obj.tag.text == '') {
      } else if (obj.tag.text.length > 20) {
        this.errorTag.push('overmaxlength')
        obj.error()
      } else if (this.replies.length > 10) {
        this.errorTag.push('overtagmax')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        // this.replies.map(t => t.text).indexOf(obj.tag.text) !== -1s
        this.errorTag.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    checkUserTags(obj) {
      this.errorTag = []
      if (obj.tag.text == '') {
      } else if (obj.tag.text.length > 20) {
        this.errorTag.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorTag.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    onDeleteGeneric(index) {
      this.generics.splice(index, 1)
    },
    onMove: function (index, direction) {
      var vm = this
      if (direction === 'left') {
        vm.generics.splice(index, 0, vm.generics.splice(index - 1, 1)[0])
      } else if (direction === 'right') {
        vm.generics.splice(index, 0, vm.generics.splice(index + 1, 1)[0])
      }
    },
    onChangeReplyComment: function () {
      if (this.isReplyComment) {
        this.intent.context_in = 'comment'
        this.replyComment = ''
      } else {
        this.intent.context_in = ''
        this.replyComment = ''
      }
    },
    onChangeIntentStatus: function () {
      let intentstatus = this.intent.intentstatus ? this.intent.intentstatus : false
      this.$set(this.intent, 'intentstatus', !intentstatus)
    },
    onChangeIntentOnlyTime: function () {
      let onlytime = this.intent.onlytime ? this.intent.onlytime : false

      this.$set(this.intent, 'onlytime', !onlytime)
    },
    addIntentPrefill: function (prefill) {
      var vm = this
      let cursorPosition = this.$refs.replyComment.$el.selectionStart
      vm.replyComment = [
        vm.replyComment.slice(0, cursorPosition),
        '{' + prefill + '}',
        vm.replyComment.slice(cursorPosition),
      ].join('')
    },
    addEmoji: function (emoji) {
      var vm = this
      let cursorPosition = this.$refs.answer[this.currentIndex].$el.selectionStart
      vm.replyComment = [
        vm.replyComment.slice(0, cursorPosition),
        emoji.native,
        vm.replyComment.slice(cursorPosition),
      ].join('')
      vm.showEmoji = false
    },
    changeIntentType: function (type) {
      var vm = this
      if (type == 'text' && (vm.intent.a_type == '' || vm.intent.a_type == null)) {
        this.text = this.intent.a_val
      }

      if (vm.intent.a_type == 'text') {
        this.text = this.intent.a_val
      }

      if (type == 'text') {
        this.intent.a_val = this.text
      }
      vm.intent.a_type = type
    },
    addReplies: function (newTags) {
      this.replies = newTags
      // console.log(newTags,this.replies)
    },
    addUserTags: function (newTags) {
      this.usertags = newTags
    },
    onSelected(option) {
      this.selected = option.item
    },
    onInputChange(text) {
      if (text === '' || text === undefined) {
        return
      }

      /* Full control over filtering. Maybe fetch from API?! Up to you!!! */
      const filteredData = this.options[0].data
        .filter((item) => {
          return item.toLowerCase().indexOf(text.toLowerCase()) > -1
        })
        .slice(0, this.limit)

      this.filteredOptions = [
        {
          data: filteredData,
        },
      ]
    },
  },
  watch: {
    showPreview: function (newVal, oldVal) {
      if (newVal) {
        $('body').addClass('modal-open')
      } else {
        $('body').removeClass('modal-open')
      }
    },
    'intent.context_in': function (newVal, oldVal) {
      if (newVal == 'comment') {
        this.isReplyComment = true
      } else {
        this.isReplyComment = false
      }
    },
    tickettags(val, prev) {
      if (val.length === prev.length) return

      this.ticket.tags = val.map((v) => {
        if (typeof v === 'string') {
          v = {
            text: v,
          }
          this.$nextTick(() => {
            this.tagitems.push(v)
            this.$forceUpdate()
          })
        }

        return v
      })
    },
    value: function (newVal, oldVal) {
      var vm = this
      vm.intent = Object.assign({}, vm.value)
      vm.cached_intent = Object.assign({}, vm.value)
      if (vm.intent.starttime) {
        var startTime = moment(vm.intent.starttime)
        vm.startDate = startTime.format('YYYY-MM-DD')
        vm.startTime = startTime.format('HH:mm')
      }
      if (vm.intent.endtime) {
        var endTime = moment(vm.intent.endtime)
        vm.endDate = endTime.format('YYYY-MM-DD')
        vm.endTime = endTime.format('HH:mm')
      }

      if (vm.value.a_type == 'text') {
      }

      if (vm.value.a_type == 'template') {
        if (vm.isJsonParseable(vm.value.a_val)) {
          vm.generics = JSON.parse(vm.value.a_val)
        } else {
          vm.generics = []
        }
      }

      if (vm.value.a_type == 'json') {
        if (vm.isJsonParseable(vm.value.a_val)) {
          vm.messages = JSON.parse(vm.value.a_val)
        } else {
          vm.messages = []
        }
      }

      if (vm.value.context_in == 'comment') {
        vm.replyComment = vm.value.a_val
      }
    },
    excludedIntentName: function () {
      var vm = this
      vm.intents = vm.excludedIntentName.split(',')
      vm.intents.push('comment')
      vm.intents.push('{default}')
      vm.intents.push('{welcome}')
      vm.intents.push('{default_comment_to_inbox}')

      if (vm.type == 'edit' && vm.excludedIntentName && vm.excludedIntentName != '' && vm.intent) {
        var result = []
        var names = vm.intents
        $.each(names, function (index, name) {
          if (name == vm.intent.intentname) {
            names.splice(index, 1)
            return false
          }
        })

        vm.excludedName = names.join(',').replace('|', '//#or//')
      } else {
        vm.excludedName = vm.intents.join(',').replace('|', '//#or//')
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/view/intent/intent-manage.vue